import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { CrudService, ModulesBasedApiSuffix, prepareGetRequestHttpParams, RxjsService, setRequiredValidator } from "@app/shared";
import { CustomerModuleApiSuffixModels } from "@modules/customer";
import { DoaLevelAndRoleAddEditModel } from "@modules/others/configuration/models/doa-level-and-role-model";
import { UserModuleApiSuffixModels } from "@modules/user";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";


@Component({
    selector: 'app-doa-role-level-add-edit-component',
    templateUrl: './doa-role-level-add-edit-component.html',
})
export class DoaRoleLevelAddEditComponent implements OnInit {


    doaRoleAndLevelAddEditForm: FormGroup;
    roleList: any;
    levelList = Array.from({ length: 50 }, (_, i) => i + 1)
    doaLevelConfigId: any;
    saveOfferDOALevelConfigId: any;

    constructor(
        private ref: DynamicDialogRef,
        private crudService: CrudService,
        public config: DynamicDialogConfig,
        private formBuilder: FormBuilder,
        private rxjsService: RxjsService) {
    }

    ngOnInit(): void {
        this.rxjsService.setDialogOpenProperty(true);
        this.saveOfferDOALevelConfigId = this.config?.data?.row?.saveOfferDOALevelConfigId ? this.config?.data?.row?.saveOfferDOALevelConfigId : null;
        this.createLevelForm();
        this.getRoles();
    }

    getRoles() {
        this.crudService.dropdown(ModulesBasedApiSuffix.IT_MANAGEMENT, UserModuleApiSuffixModels.UX_RoLES,
            prepareGetRequestHttpParams(null, null, null)).subscribe((response) => {
                if (response.isSuccess && response.statusCode == 200) {
                    this.roleList = response.resources;
                }
            });
    }

    createLevelForm(doaLevelAndRoleAddEditModels?: DoaLevelAndRoleAddEditModel): void {
        let doaLevelAndRoleAddEditModel = new DoaLevelAndRoleAddEditModel(doaLevelAndRoleAddEditModels);
        if (doaLevelAndRoleAddEditModel.doaLevelConfigId) {
            this.doaLevelConfigId = doaLevelAndRoleAddEditModel.doaLevelConfigId;
        }
        this.doaRoleAndLevelAddEditForm = this.formBuilder.group({});
        Object.keys(doaLevelAndRoleAddEditModel).forEach((key) => {
            this.doaRoleAndLevelAddEditForm.addControl(key, (key == 'createdUserId') ? new FormControl(this.config?.data?.row?.createdUserId) :
                new FormControl(doaLevelAndRoleAddEditModel[key]));
        });
        this.doaRoleAndLevelAddEditForm = setRequiredValidator(this.doaRoleAndLevelAddEditForm, ["level", "roleId"]);
        this.setValue();
    }
    setValue() {
        this.doaRoleAndLevelAddEditForm.get('level').setValue(this.config?.data?.row?.level || '');
        this.doaRoleAndLevelAddEditForm.get('roleId').setValue(this.config?.data?.row?.roleId || '');
    }
    onSubmit(): void {
        if (this.doaRoleAndLevelAddEditForm.invalid) return;
        let formValue = this.doaRoleAndLevelAddEditForm.value;
        let finalObject = {
            saveOfferDOALevelConfigId: this.saveOfferDOALevelConfigId,
            roleId: formValue.roleId,
            level: formValue.level,
            createdUserId: this.config?.data?.row?.createdUserId,
            isOverWriteExistingLevel: true
        }
        this.crudService.create(ModulesBasedApiSuffix.CUSTOMER_MANAGEMENT, CustomerModuleApiSuffixModels.SAVE_OFFER_DOA_LEVEL_CONFIG, finalObject, 1).subscribe((response) => {
            if (response.isSuccess && response.statusCode === 200) {
                this.doaRoleAndLevelAddEditForm.reset();
                this.ref.close(response);
                this.rxjsService.setDialogOpenProperty(false);
            }
        })
    }

    btnCloseClick() {
        this.ref.close(false);
    }

    ngOnDestroy(): void {
        this.rxjsService.setDialogOpenProperty(false);
    }
}